import fetch from 'isomorphic-fetch';
import cookie from 'react-cookie';
import config from '../config';

const checkStatus = (res) => {
  if (res.status >= 200 && res.status < 300) return res;
  const error = new Error(res.statusText);
  error.response = res;
  error.statusCode = res.status;
  throw error;
};

const parseJSON = response => response.json();

const doFetch = (path, options) => {
  const at = cookie.load('access_token');
  if (at) { // todo remove
    path += `&accesstoken=${at}`; // eslint-disable-line no-param-reassign
  }

  return fetch(`${config.productAPI}${path}`, {
    // headers: {
    //   'X-Auth-AccessToken': cookie.load('access_token'),
    // },
    ...options,
  })
    .then(checkStatus)
    .then(parseJSON);
};

export const createParamString = params => Object.keys(params)
  .filter(key => (params[key] !== undefined && params[key] !== null))
  .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
  .join('&');

export default doFetch;



// WEBPACK FOOTER //
// ./src/common/baseFetch.js